import axios from "axios";

export const apiPut = async (url, data, session, cancelToken, headers = {
}) => {
  return await axios.put(
    url,
    data,
    {
      headers: {
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
        ...headers
      },
      cancelToken,
    }
  ).catch(function (thrown) {
    if (axios.isCancel(thrown)) {
      console.log('Request canceled', thrown.message);
    } else {
    }
  })
}

export const apiPost = async (url, data, session, cancelToken, headers = {
}) => {
  return await axios.post(
    url,
    data,
    {
      headers: {
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
        ...headers
      },
      cancelToken,
    }
  ).catch(function (thrown) {
    if (axios.isCancel(thrown)) {
    } else {
    }
  });
}

export const apiGet = async (url, session, params = {}, cancelToken, headers = {
}) => {
  return await axios.get(
    url,
    {
      params,
      headers: {
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
        ...headers
      },
      cancelToken,
    }
  ).catch(function (thrown) {
      if (axios.isCancel(thrown)) {
        console.log('Request canceled', thrown.message);
      } else {
      }
    }
  )

}

export const apiDelete = async (url, session, params = {}, cancelToken, headers = {
}) => {
  return await axios.delete(
    url,
    {
      params,
      headers: {
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
        ...headers
      },
      cancelToken,
    }
  ).catch(function (thrown) {
    if (axios.isCancel(thrown)) {
      console.log('Request canceled', thrown.message);
    } else {
    }
  });
}